import {createSlice} from "@reduxjs/toolkit";
import {ResponseApi} from '../BaseApi';
import {CreateIngredient, CreateIngredientImage, DeleteAllergenById, DeleteDietTypeById, DeleteIngredientById, GetMeasurementUnits, UpdateIngredient} from './IngredientApi';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const IngredientSlice = createSlice({
    name: "ingredient",
    initialState: {
        measurementUnitsAll: null,
        addEdit: null,
        ingredientImage: null,
        deleteAllergen:null,
        deleteDietType:null,
        deleteIngredient:null,
    },
    reducers: {
        resetMeasurementUnitsAll: (state, action) => {
            state.measurementUnitsAll = null;
        }
    },
    extraReducers: (builder) => {
        builder.
        addCase(GetMeasurementUnits.fulfilled, (state, {payload}) =>{
            state.measurementUnitsAll = ResponseApi(payload);
        }).addCase(CreateIngredient.fulfilled, (state, {payload}) =>{
            state.addEdit = ResponseApi(payload);
        }).addCase(CreateIngredientImage.fulfilled, (state, {payload}) =>{
            state.ingredientImage = ResponseApi(payload);
        }).addCase(UpdateIngredient.fulfilled, (state, {payload}) =>{
            state.addEdit = ResponseApi(payload);
        }) .addCase(DeleteAllergenById.fulfilled, (state, { payload }) => {
            state.deleteAllergen = ResponseApi(payload);
        }) .addCase(DeleteDietTypeById.fulfilled, (state, { payload }) => {
            state.deleteDietType = ResponseApi(payload);
        }) .addCase(DeleteIngredientById.fulfilled, (state, { payload }) => {
            state.deleteIngredient = ResponseApi(payload);
        })
    }

})

export const { resetMeasurementUnitsAll } = IngredientSlice.actions;

export default IngredientSlice.reducer;
